import React, { useState, useEffect, useCallback } from "react";
import { Breadcrumb, Button, Drawer, Select } from "antd";
import { DoubleRightOutlined, DownloadOutlined, ReloadOutlined } from "@ant-design/icons";
import ShimmerLoader from "../../loading";
import "../../../src/styles.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import LoadingSpinner from "../../components/Loading";

import dayjs from "dayjs";
import i18next from "i18next";
import { toast } from "react-toastify";
import DateFilter from "../../components/ui/DateFilter";
import { URLS } from "../../API/API endpoints";
import axiosInstance from "../../AxiosInstance";
import moment from "moment";
import { checkPermission } from "../../Utils/permissionHelper";
import ExportCasInOutReportModal from "../../app/SessionHistory/ExportCasInOutReportModal";
import GroupWiseTable from "./Tables/GroupWiseTable";
import SearchBox from "../CustomWidgets/SearchBox";

  const debounce = (func, delay) => {
    let timer;
    return function (...args) {
      const context = this;
      clearTimeout(timer);
      timer = setTimeout(() => func.apply(context, args), delay);
    };
  };


const GroupSaleReport = () => {
    const { t, i18n } = useTranslation();
    const { Option } = Select;

    const company_id = useSelector((state) => state?.login?.user?.result?.company_id);
    const allStores = useSelector((state) => state?.storeReducer?.selectedStore?.is_select_all_store);
    const isGinne = useSelector((state) => state?.geneLoginReducer?.isGinneLogin);

    const [loading, setloading] = useState(false);
    const [saleSummary, setSaleSummary] = useState([]);

    const today = dayjs();
    const [startDate, setStartDate] = useState(today.startOf("month").format("YYYY-MM-DD"));
    const [endDate, setEndDate] = useState(today.format("YYYY-MM-DD"));
    const [selectedRange, setSelectedRange] = useState("thisMonth");

    const [currentLimit, setCurrentLimit] = useState(10);
    const [currentOffset, setCurrentOffset] = useState(0);

    const [exportModalOpen, setExportModalOpen] = useState(false);
    const [categoryLoading, setCategoryLoading] = useState(false);

    // ⭐ NEW SESSION FILTER STATES
    const [allSessions, setAllSessions] = useState([]);
    const [selectedSession, setSelectedSession] = useState(null);
  const [searchByShortCode, setSearchByShortCode] = useState(false);
  const [query, setquery] = useState("");


    useEffect(() => {
        GetSessions();
        GetGroupSaleSummary(query, startDate, endDate, selectedSession, currentOffset, currentLimit);
    }, [currentLimit, currentOffset]);

    // ⭐ API CALL - GET SESSIONS
    const GetSessions = async () => {
        try {
            const response = await axiosInstance.post(URLS.GET_POS_SESSION_LIST, {
                company_id,
                lang: i18n.language === "ar" ? "ar_001" : "en_US",
            });

            if (response?.data?.result?.status_code === 200) {
                setAllSessions(response.data.result.data);
            } else {
                setAllSessions([]);
            }
        } catch (error) {
            console.error("Error fetching sessions:", error);
            setAllSessions([]);
        }
    };

    // ⭐ API CALL - UPDATED WITH SESSION FILTER
    const GetGroupSaleSummary = async (text, start, end, session, offset, limit) => {
        setloading(true);
        try {
            const response = await axiosInstance.post(URLS.GET_GROUP_WISE_SALES, {
                 search: searchByShortCode ? '' : text,
        short_code: searchByShortCode ? text : '',
                company_id,
                offset,
                limit,
                start_date: start,
                end_date: end,
                session_id: session || "",  // 🔥 session filter applied
                lang: i18n.language === "ar" ? "ar_001" : "en_US",
            });

            if (response?.data?.result?.status_code === 200) {
                setSaleSummary(response?.data?.result?.data);
            } else {
                setSaleSummary([]);
            }
        } catch (error) {
            console.error("Group sale fetch error:", error);
        } finally {
            setloading(false);
            setCategoryLoading(false);
        }
    };

    // ⭐ USER SELECTS SESSION
    const onSessionChange = (id) => {
        setSelectedSession(id);
        setCurrentLimit(10);
        setCurrentOffset(0);
setquery('');
        GetGroupSaleSummary('',startDate, endDate, id, 0, 10);
    };

    // REFRESH
    const handleRefresh = () => {
        GetGroupSaleSummary(query, startDate, endDate, selectedSession, currentOffset, currentLimit);
    };

    // EXPORT FUNCTION
    const handleExport = async (dates) => {
        let payload = {
            lang: i18next.language === "ar" ? "ar_001" : "en_US",
            start_date: dates?.startDate,
            end_date: dates?.endDate,
            company_id: company_id,
        };

        const response = await axiosInstance.post(URLS.GET_CASHIER_GROUP_SALE_EXCEL, payload);

        if (response?.data?.result?.status_code == 200) {
            setExportModalOpen(false);
            downloadFile(response?.data?.result?.file_base64);
        } else {
            toast.error(response?.data?.result.status);
        }
    };

    const downloadFile = (data) => {
        try {
            let cleanBase64 = data.trim().replace(/^data:[\w/+-]+;base64,/, "").replace(/\s/g, "");
            const binaryString = atob(cleanBase64);
            const bytes = new Uint8Array(binaryString.length);
            for (let i = 0; i < binaryString.length; i++) bytes[i] = binaryString.charCodeAt(i);

            const blob = new Blob([bytes], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            const filename = `${t("group_wise_sale")}_${moment().format("YYYY-MM-DD_HH.mm.ss")}.xlsx`;
            const url = URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = filename;
            link.click();

            setTimeout(() => URL.revokeObjectURL(url), 200);
        } catch (error) {
            alert("Download failed");
        }
    };


            const debouncedSearch = useCallback(
              debounce((value) => {
                  GetGroupSaleSummary(value, startDate, endDate, null, 0, 10);
              }, 1000),
              [searchByShortCode, startDate, endDate],
            );

    return (
        <>
            {loading && <LoadingSpinner />}

            <div className="w-full flex flex-col pb-2 overflow-y-auto mt-3">

                {/* Filters Row */}
                <div className="flex items-center justify-between">

                    <div className="flex items-center">

                        {/*SESSION FILTER DROPDOWN */}
                        <Select
                            showSearch
                            optionFilterProp="children"
                            className="overflow-hidden"
                            style={{ width: 340, minWidth: 200, height: 40 }}
                            placeholder={t("All Sessions")}
                            value={selectedSession ?? null}
                            onChange={onSessionChange}
                        >
                            <Option value={null}>{t("All Sessions")}</Option>

                            {allSessions.map((session) => (
                                <Option key={session?.id} value={session?.id}>
                                    {session?.name}
                                </Option>
                            ))}
                        </Select>

                        {/* DATE FILTER */}
                        <div className="mb-2 ms-3">
                            <DateFilter
                                setSelectedRange={setSelectedRange}
                                selectedRange={selectedRange}
                                SubmitFilter={(start, end) => {
                                    setStartDate(start);
                                    setEndDate(end);
                                    setCurrentLimit(10);
                                    setCurrentOffset(0);
                                    setquery('')
                                    GetGroupSaleSummary(query, start, end, selectedSession, 0, 10);
                                }}
                            />
                        </div>
                    </div>
<div className="flex gap-x-2 items-center">
     <div className="flex justify-end mx-8">
                    <button
                        className="w-48 h-10 bg-primaryBlue text-white text-sm font-semibold rounded-lg flex items-center justify-center gap-2"
                        onClick={() => {
                            if (allStores || checkPermission("/pos/CategoryWiseSale", isGinne)) {
                                setExportModalOpen(true);
                            }
                        }}
                    >
                        <DownloadOutlined style={{ fontSize: "1.5em" }} />
                        <span>{t("Download in Excel")}</span>
                    </button>
                </div>
                 <div
                        className="flex justify-center items-center text-gray-500 cursor-pointer text-sm me-8"
                        onClick={handleRefresh}
                    >
                        <ReloadOutlined />
                        <p className="ms-2">{t("Refresh")}</p>
                    </div>
</div>
                    {/* REFRESH BUTTON */}
                   
                </div>

                {/* EXPORT BUTTON */}
               
       <div className="flex justify-between items-end">
 <div className="flex gap-x-2 mt-3 ">
                         <div className="">
                <SearchBox
                value={query}
                  // showBarcode={true}
                  searchResult={(values) => {
                    setquery(values)
                       setloading(true);
                       setSelectedSession(null);
                    debouncedSearch(values)}}
                  placeholder={t("Search by Product")}
                />
              </div>
              <button
                type="button"
                onClick={() => {
                  setSearchByShortCode(!searchByShortCode);
                }}
                className={`h-[40px] px-2 rounded-md border text-sm whitespace-nowrap ${
                  searchByShortCode
                    ? "bg-blue-100 border-primaryBlue text-primaryBlue"
                    : "bg-white border-gray-300 text-gray-700"
                }`}
              >
                {t("Search Code")}
              </button>
                    </div>
                {/* <div className="flex justify-end mt-3 mx-8 gap-3"> */}
                    {/* Clear Filter Button */}
                    <button
                        className="h-10 px-4 text-primaryBlue text-sm font-semibold rounded-lg flex items-center justify-center gap-2"
                        onClick={() => {
                            // Reset session
                            setSelectedSession(null);

                            // Reset date to current month
                            const today = dayjs();
                            const defaultStart = today.startOf("month").format("YYYY-MM-DD");
                            const defaultEnd = today.format("YYYY-MM-DD");
                            setStartDate(defaultStart);
                            setEndDate(defaultEnd);
                            setSelectedRange("thisMonth");

                            // Reset pagination
                            setCurrentLimit(10);
                            setCurrentOffset(0);
setquery('')
                            // Fetch default data
                            GetGroupSaleSummary('', defaultStart, defaultEnd, null, 0, 10);
                        }}
                    >
                        {t("Clear Filter")}
                    </button>
                </div>

                {/* TABLE */}
                {categoryLoading ? (
                    <ShimmerLoader />
                ) : (
                    <GroupWiseTable
                        additionalData={saleSummary}
                        pagination={(values) => {
                            setCurrentLimit(values.limit);
                            setCurrentOffset(values.offset);
                        }}
                    />
                )}
            </div>

            {exportModalOpen && (
                <ExportCasInOutReportModal
                    heading={t("Download Group Wise Sale")}
                    isOpen={exportModalOpen}
                    onClose={() => setExportModalOpen(false)}
                    onExport={(dates) => handleExport(dates)}
                />
            )}
        </>
    );
};

export default GroupSaleReport;
